import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findOrderList,
	findOrderDetailList,
	changeOrderActivePage, 
	deleteOrder, 
	openAddOrderModal, 
	openEditOrderModal,
	openEditOrderDetailModal,
	openViewOrderModal,
	findOrder
} from '../actions';

function checkShowCheckBox(roles) {
	return (roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD") || roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD_LABOR"));
}

function checkDisableAdd(roles) {
	return !(roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD") || roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD_LABOR"));
}

function checkDisableEdit(roles) {
	return false;
}

function checkHideEditActions(roles) {
	return !(roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD") || roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD_LABOR"));
}

const mapStateToProps = (state) => ({
	data: state.getIn(['orderListReducer', 'orderList']),
	activePage: state.getIn(['orderListReducer', 'activePage']),
	itemPerPage: state.getIn(['orderListReducer', 'itemPerPage']),
	totalPage: state.getIn(['orderListReducer', 'totalPage']),
	searchWord: state.getIn(['orderListReducer', 'searchWord']),
	pagingMaxButtons: 5,
	fields: {
		order_id: '訂單編號',
		customer_name: '客戶名稱',
		order_date: '訂單日期',
		due_date: '交期',
		sales: '負責業務'
	},
	keys: ['order_id'],
	searchKeys: ['orders.order_id', 'customers.customer_name', 'orders.sales'],
	showCheckBox: checkShowCheckBox(state.getIn(['authReducer', 'roles']).toJS()),
	disableAdd: checkDisableAdd(state.getIn(['authReducer', 'roles']).toJS()),
	disableEdit: checkDisableEdit(state.getIn(['authReducer', 'roles']).toJS()),
	hideEditActions: checkHideEditActions(state.getIn(['authReducer', 'roles']).toJS()),
	showEditMore: true,
	edit1: {
		className: 'glyphicon glyphicon-pencil',
		showText: 'Edit Detail'
	},
	edit2: {
		className: 'glyphicon glyphicon-eye-open',
		showText: 'View'
	}
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (pagingData) => {
		dispatch(findOrderList(pagingData));
	},
	changeActivepage: (pagingData, searchData) => {
		dispatch(changeOrderActivePage(pagingData));
		dispatch(findOrderList(pagingData, searchData));
	},
	deleteItems:(deleteKey, pagingData) => {
		dispatch(deleteOrder(deleteKey, pagingData));
	},
	openAddModal:() => {
		dispatch(openAddOrderModal({forInsert:true}));
	},
	handleEdit:(pk) => {
		dispatch(findOrder(pk));
		dispatch(openEditOrderModal({forInsert:false}));
	},
	handleEdit1:(pk) => {
		dispatch(findOrder(pk));
		dispatch(findOrderDetailList({orderId: pk.order_id}));
		dispatch(openEditOrderDetailModal({orderId: pk.order_id}));
	},
	handleEdit2:(pk) => {
		dispatch(findOrder(pk));
		dispatch(findOrderDetailList({orderId: pk.order_id}));
		dispatch(openViewOrderModal());
	},
	search:(pagingData, searchData) => {
		dispatch(findOrderList(pagingData, searchData));
	}
})

const OrderListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default OrderListContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderListContainer.jsx